import { DateTime } from './DateTime';

export class Duration {
  #value: number; //milliseconds

  constructor(value: number) {
    if (Number.isSafeInteger(value)) {
      this.#value = value;
    } else {
      throw new Error(
        'Duration must be constructed with an integer of milliseconds',
      );
    }
  }

  public get value(): number {
    return this.#value;
  }

  public addToDate(a: DateTime): DateTime {
    return new DateTime(a.value + this.#value);
  }
}

export const zeroDuration = new Duration(0);

//TODO: Consider an LRU cache for durationFactory. At this time there is not enough usage of Duration to consolidate.

export const durationFactory = (value: number): Duration => {
  if (value === 0) {
    return zeroDuration;
  }
  return new Duration(value);
};
